var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipseHighScore = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#006D2E",
    clipPath: "url(#" + _uid + "ellipse-high-score_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.667a.7.7 0 0 0-.47.177.58.58 0 0 0-.196.429V9.09c0 .16.07.315.195.429a.7.7 0 0 0 .472.177.7.7 0 0 0 .471-.177.58.58 0 0 0 .195-.429V7.273a.58.58 0 0 0-.195-.429.7.7 0 0 0-.471-.177M8.528.178A.7.7 0 0 1 9 0c.176 0 .346.064.471.178a.58.58 0 0 1 .195.428v8.485a.58.58 0 0 1-.195.428.7.7 0 0 1-.471.178.7.7 0 0 1-.472-.178.58.58 0 0 1-.195-.428V.606c0-.16.07-.315.195-.428M5.862 2.602a.7.7 0 0 1 .472-.178c.176 0 .346.064.471.178A.58.58 0 0 1 7 3.03v6.061a.58.58 0 0 1-.195.429.7.7 0 0 1-.471.177.7.7 0 0 1-.472-.177.58.58 0 0 1-.195-.429v-6.06c0-.161.07-.316.195-.43M3.195 5.026a.7.7 0 0 1 .472-.178c.176 0 .346.064.471.178a.58.58 0 0 1 .195.428v3.637a.58.58 0 0 1-.195.428.7.7 0 0 1-.471.178.7.7 0 0 1-.472-.178A.58.58 0 0 1 3 9.091V5.454c0-.16.07-.314.195-.428"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "ellipse-high-score_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
};
export { SvgEllipseHighScore as ReactComponent };
export default __webpack_public_path__ + "e32799904fe33c42f12c6db28497cce8.svg";